<div class="header">
  <div *ngIf="safeguardstyle" style="flex:1">
    <select class="safeguard-dropdown" [(ngModel)]="selectedlanguage" (change)="changeLanguage(this.selectedlanguage)">
        <option *ngFor="let l of languages" value="{{ l.abr }}">
        {{ l.language }}
        </option>
    </select>

  </div>
  <div *ngIf="safeguardstyle && equipment != null && equipment != undefined" style="flex:2;text-align: center;">{{'TXT-HEADER' | translate:translations:selectedlanguage}} - {{equipment.SERIALNUMB}}</div>
  <div style="flex:1" class="bannerwrapper"> <img src="assets/images/logo.png" class="bannerlogo" /></div>
<!-- (click)="switchmode()" -->

</div>
<div class="content" *ngIf="loadingEquipment">
  <div style="display:flex; flex-direction: column; justify-content: center;align-items: center;">
    <app-loading-icon></app-loading-icon>
    <div>
      <h2>{{'TXT-LOADING' | translate:translations:selectedlanguage}}</h2>
    </div>
  </div>
</div>
<div class="content" *ngIf="saving">
  <div style="display:flex; flex-direction: column; justify-content: center;align-items: center;">
    <app-loading-icon></app-loading-icon>
    <div>
      <h3>{{'TXT-SAVING' | translate:translations:selectedlanguage}}</h3>
    </div>
  </div>
</div>


<!-- TAKING PICTURE -->
<div (window:resize)="onResize($event)" style="width: 90%">

  <div class="content" *ngIf="takingPicture">
    <webcam [height]="500" [width]="width" [trigger]="triggerObservable" (imageCapture)="handleImageTaken($event)"
      [allowCameraSwitch]="allowCameraSwitch" [switchCamera]="nextWebcamObservable" [videoOptions]="videoOptions"
      [imageQuality]="1" (cameraSwitched)="cameraWasSwitched($event)" (initError)="handleInitError($event)"
      [imageQuality]="0.35"></webcam>


    <div class="button-wrapper">
      <button class="btn btn-error" (click)="cancelPhoto();">{{'BTN-CANCEL' | translate:translations:selectedlanguage}}</button>
      <button class="btn btn-main" (click)="triggerSnapshot();">{{'BTN-PHOTO' | translate:translations:selectedlanguage}}</button>
    </div>
  </div>

</div>

<div class="safeguardstyle" *ngIf="safeguardstyle">
  <div class="content" *ngIf="!loadingEquipment && step < questions.length && !takingPicture && !finished && !saving">
    <div class="questionCount">
      {{'TXT-QUESTION' | translate:translations:selectedlanguage}} {{step+1}} {{'TXT-STEP' | translate:translations:selectedlanguage}} {{questions.length}}
    </div>
    <div>
      <div *ngFor="let question of questions">
        <div *ngIf="currentQuestion.QuestionID == question.QuestionID">

          <div class="questionTitle" *ngIf="selectedlanguage == 'eng'" >{{question.QuestionText}}</div>
          <div class="questionTitle" *ngIf="selectedlanguage == 'alb'" >{{question.Question_Albanian}}</div>
          <div class="questionTitle" *ngIf="selectedlanguage == 'est'" >{{question.Question_Estonian}}</div>
          <div class="questionTitle" *ngIf="selectedlanguage == 'fin'" >{{question.Question_Finnish}}</div>
          <div class="questionTitle" *ngIf="selectedlanguage == 'rom'" >{{question.Question_Romainian}}</div>

          <div *ngIf="question.FreeTextOrDropdown == 0">
            <div class="repsonseWrapper">
              <div *ngFor="let r of question.Responses; let i=index">
                <div class="radio">

                  <input type="radio" class="radioButton" id="{{r.GuidResponseID}}" name="radio{{r.GuidResponseID}}"
                    [value]="r.ResponseID" [(ngModel)]="question.ResponseID" (change)="responseChanged(question,r)" />
                  <label *ngIf="selectedlanguage == 'eng'" for="{{r.GuidResponseID}}">{{r.ResponseName}}</label>
                  <label *ngIf="selectedlanguage == 'alb'" for="{{r.GuidResponseID}}">{{r.ResponseName_Albanian}}</label>
                  <label *ngIf="selectedlanguage == 'est'" for="{{r.GuidResponseID}}">{{r.ResponseName_Estonian}}</label>
                  <label *ngIf="selectedlanguage == 'fin'" for="{{r.GuidResponseID}}">{{r.ResponseName_Finnish}}</label>
                  <label *ngIf="selectedlanguage == 'rom'" for="{{r.GuidResponseID}}">{{r.ResponseName_Romainian}}</label>
                </div>
              </div>
            </div>
          </div>


          <div *ngIf="question.FreeTextOrDropdown == 1">
            <div class="repsonseWrapper">
              <div *ngFor="let r of question.Responses; let i=index">
                <div class="radio">

                  <input type="checkbox" class="radioButton" id="{{r.GuidResponseID}}" name="radio{{r.GuidResponseID}}"
                    [value]="r.ResponseID" [(ngModel)]="question.ResponseID" (change)="responseChanged(question,r)" />
                  <label *ngIf="selectedlanguage == 'eng'" for="{{r.GuidResponseID}}">{{r.ResponseName}}</label>
                  <label *ngIf="selectedlanguage == 'alb'" for="{{r.GuidResponseID}}">{{r.ResponseName_Albanian}}</label>
                  <label *ngIf="selectedlanguage == 'est'" for="{{r.GuidResponseID}}">{{r.ResponseName_Estonian}}</label>
                  <label *ngIf="selectedlanguage == 'fin'" for="{{r.GuidResponseID}}">{{r.ResponseName_Finnish}}</label>
                  <label *ngIf="selectedlanguage == 'rom'" for="{{r.GuidResponseID}}">{{r.ResponseName_Romainian}}</label>
                                </div>
              </div>
            </div>
          </div>
          <div *ngIf="question.FreeTextOrDropdown == 2">
          </div>

          <textarea wrap="soft" type="text"
            style="resize:vertical;width:100%;margin-bottom: 0.5rem;white-space: pre-wrap;" rows="3"
            name="ResponseFreeText" [innerHTML]="question.ResponseFreeText" placeholder="{{'PLH-COMMENTS' | translate:translations:selectedlanguage}} "
            [(ngModel)]="question.ResponseFreeText"></textarea>

          <div class="button-wrapper">
            <div style="flex:1" *ngIf="step == 0"></div>
            <button (click)="back(question)" *ngIf="step > 0" class="btn btn-error">{{'BTN-BACK' | translate:translations:selectedlanguage}}</button>

            <button (click)="next(question)" class="btn btn-main">{{'BTN-NEXT' | translate:translations:selectedlanguage}}</button>
          </div>

          <div class="button-wrapper">
            <img class="pictureImg" (click)="takePicture(question)" src="../../../assets/capture_image_128.png" />
            <img class="pictureImg" (click)="openFilePicker(question.QuestionID)"
              src="../../../assets/faselectnew.png" />
            <input type="file" accept="image/*" class="inputfile" [id]="'filePickerPopup' + question.QuestionID"
              style="display: none;" (change)="changeListener(question,$event)" />

          </div>
          <div class="snapshot" *ngIf="question.image">
            <img [src]="question.image" class="takenphoto" />
          </div>

        </div>

      </div>
    </div>
  </div>



  <div class="content" *ngIf="!loadingEquipment && step >= questions.length && !takingPicture && !finished && !saving">
    <div style="display: flex;flex-direction: column;">
      <div style="display: flex;flex-direction: column;">
        <label>{{'TXT-NAME' | translate:translations:selectedlanguage}}</label>
        <input type="text" name="engineer" class="form-control" placeholder="{{'PLH-NAME' | translate:translations:selectedlanguage}}"
          [(ngModel)]="weeklyInspection.engineer">
      </div>
      <div style="display: flex;flex-direction: column;margin-bottom:5vh">
        <label>{{'TXT-CONTRACTOR' | translate:translations:selectedlanguage}} </label>
        <div>
          <search-dropdown [items]="locations" [label]="'SN_ADDR1'" [uid]="'LocationID'"
            (afterChange)="onLocationChange($event)"
            [(ngModel)]="weeklyInspection.LocationID">
          </search-dropdown>


        </div>
      </div>
      <div style="display: flex;flex-direction: column;">
        <label>{{'TXT-SIGCONFIRM' | translate:translations:selectedlanguage}}</label>

        <div style="width:100%;">
          <canvas #canvas style="touch-action: none;background-color: #e3e3e3;border:none"></canvas>
          <div class="button-wrapper">
            <button class="btn btn-main" (click)="clearSignature();">{{'BTN-CLEAR' | translate:translations:selectedlanguage}}</button>
            <!-- <button class="btn btn-main" (click)="undoSignature();">Undo</button> -->
          </div>
        </div>

      </div>


      <div class="button-wrapper" style="position:fixed;bottom: 0;right: 0;">
        <button (click)="back()" *ngIf="!loadingEquipment && step >= questions.length"
          class="btn btn-error">{{'BTN-BACK' | translate:translations:selectedlanguage}}</button>

        <button class="btn btn-main" (click)="saveInspection();">{{'BTN-SAVE' | translate:translations:selectedlanguage}}</button>
      </div>


    </div>
  </div>

  <div class="content" *ngIf="finished">
    <div *ngIf="safeguardstyle" style="flex:1;text-align: center;">{{'TXT-THANKS' | translate:translations:selectedlanguage}}     </div>
    <div *ngIf="safeguardstyle" style="flex:1;text-align: center;">{{'TXT-SAFETOCLOSE' | translate:translations:selectedlanguage}}</div>

  </div>
</div>
<div *ngIf="!safeguardstyle && !loadingEquipment && !takingPicture">
  <div class="sceequipmentdetails" *ngIf="!safeguardstyle && !loadingEquipment">
    <table class="sceTable">
      <tr class="sceTableRow">
        <td class="sceTableRow">
          Description
        </td>
        <td class="sceTableRow">
          {{equipment.ITEMNAME}}
        </td>
      </tr>
      <tr class="sceTableRow">
        <td class="sceTableRow">
          Serial Number
        </td>
        <td class="sceTableRow">
          {{equipment.SERIALNUMB}}
        </td>
      </tr>
      <tr class="sceTableRow">
        <td class="sceTableRow">
          Asset Number
        </td>
        <td class="sceTableRow">
          {{equipment.CRSNR}}
        </td>
      </tr>
      <tr class="sceTableRow">
        <td class="sceTableRow">
          SWL
        </td>
        <td class="sceTableRow">
          {{equipment.SWL}}
        </td>
      </tr>
    </table>

  </div>

  <div class="scestyle">
    <div style="margin-bottom: 2vh;margin-top: 2vh;width:100%">
      <div *ngFor="let question of questions">
        <div style="margin-bottom: 4vh; border-bottom:1px solid #b0b0b0;width:100%">
          <div class="questionTitle">
            {{question.QuestionText}}
          </div>

          <div *ngIf="question.FreeTextOrDropdown == 0 || question.FreeTextOrDropdown == 1">
            <div class="scerepsonseWrapper">

              <div class="segmented-control">
                <div *ngFor="let r of question.Responses; let i = index">
                  <input type="radio" class="segmented-input" id="{{r.GuidResponseID}}"
                    name="question{{question.QuestionID}}" [value]="r.ResponseID" [(ngModel)]="question.ResponseID"
                    (change)="responseChanged(question, r)" />
                  <label class="segmented-label" for="{{r.GuidResponseID}}">
                    {{r.ResponseName}}
                  </label>
                </div>
              </div>

              <!-- <div *ngFor="let r of question.Responses; let i=index">
                  <div class="radio">
  
                    <input type="radio" class="radioButton" id="{{r.GuidResponseID}}" name="radio{{r.GuidResponseID}}"
                      [value]="r.ResponseID" [(ngModel)]="question.ResponseID" (change)="responseChanged(question,r)" />
                    <label for="{{r.GuidResponseID}}">{{r.ResponseName}}</label>
                  </div>
                </div> -->
            </div>
          </div>


          <textarea wrap="soft" type="text"
            style="resize:vertical;width:100%;margin-bottom: 0.5rem;white-space: pre-wrap;" rows="3"
            name="ResponseFreeText" [innerHTML]="question.ResponseFreeText" placeholder="{{'PLH-COMMENTS' | translate:translations:selectedlanguage}}"
            [(ngModel)]="question.ResponseFreeText"></textarea>

          <div class="button-wrapper">
            <img class="scepictureImg" (click)="takePicture(question)" src="../../../assets/fatakenew.png" />
            <img class="scepictureImg" (click)="openFilePicker(question.QuestionID)"
              src="../../../assets/faselectnew.png" />
            <input type="file" accept="image/*" class="inputfile" [id]="'filePickerPopup' + question.QuestionID"
              style="display: none;" (change)="changeListener(question,$event)" />

          </div>
          <div class="snapshot" *ngIf="question.image">
            <img [src]="question.image" class="takenphoto" />
          </div>

        </div>

      </div>
    </div>

    <div class="content" *ngIf="!loadingEquipment && !takingPicture && !finished && !saving">
      <div style="display: flex;flex-direction: column;">
        <div style="display: flex;flex-direction: column;">
          <label>Your Name *</label>
          <input type="text" name="engineer" class="form-control" placeholder="{{'PLH-NAME' | translate:translations:selectedlanguage}}"
            [(ngModel)]="weeklyInspection.engineer">
        </div>
        <div style="display: flex;flex-direction: column;margin-bottom:5vh">
          <label>Contractor *</label>
          <div>
            <search-dropdown [items]="locations" [label]="'SN_ADDR1'" [uid]="'LocationID'"
              (afterChange)="onLocationChange($event)"
              [(ngModel)]="weeklyInspection.LocationID">
            </search-dropdown>


          </div>
        </div>
        <div style="display: flex;flex-direction: column;">
          <label>Confirmation Signature *</label>

          <div style="width:100%;">
            <canvas #canvas style="touch-action: none;background-color: #e3e3e3;border:none"></canvas>
            <div class="button-wrapper">
              <button class="btn btn-main" (click)="clearSignature();">Clear</button>
              <button class="btn btn-main" (click)="undoSignature();">Undo</button>
            </div>
          </div>

          <button class="btn btn-main" (click)="saveInspection();">Save</button>


        </div>


      </div>
    </div>
  </div>
</div>